import { render, staticRenderFns } from "./PersonnelRecordEditTabGeneral.vue?vue&type=template&id=1d075196"
import script from "./PersonnelRecordEditTabGeneral.vue?vue&type=script&lang=js"
export * from "./PersonnelRecordEditTabGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports